import React, { useState } from "react";
import { Box, Center } from "@chakra-ui/react";
import { MultiForm } from "../MultiForm";

export function LoginPage() {
  const [isSignUp, onChange] = useState(false);
  return (
    <Center minH="100vh">
      <Box bg="bgSecondary" rounded="lg" m="6" w="full" maxW="lg">
        <MultiForm isSignUp={isSignUp} onChange={onChange} />
      </Box>
    </Center>
  );
}
